export const DEFAULT_ALERT_ROUTE = 'alerts?status=["Open"]&sortBy=Value_Desc';
export const DEFAULT_STORE_ROUTE = "";
export const DEFAULT_DEVICES_ROUTE = "";
